export type VenuePayoutReportType = 'reports' | 'invoices';

export enum AnnualReportDownloadStatus {
  Initial,
  Downloading,
  Error,
}
